







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AboutMycolorBase from './AboutMyColorBase.vue'

@Component({
  components: {
    AboutMycolorBase,
  },
})
export default class AboutMyColorPc extends Vue {
  @Prop({ default: 'div' })
  tag: string
}
